/**
 * Builds a request processing handler that delegates request processing to other handlers.
 *
 * Iterates over the given handlers in order and delegates the request processing to them. It stops when either
 * response is generated, an error thrown, or no handlers left.
 *
 * @typeParam TMeans - A type of request processing means `handlers` expect.
 * @param handlers - Either single handler or iterable of handlers to delegate request processing to.
 *
 * @returns Request processing handler.
 */
export function requestHandler(handlers) {
    if (typeof handlers === 'function') {
        return handlers;
    }
    return async (context) => {
        for (const handler of handlers) {
            if (await context.next(handler)) {
                return;
            }
        }
        return;
    };
}
//# sourceMappingURL=request-handler.js.map